import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { BeneficiaireAvecMailsModel } from 'src/graphql/generated-types';
import { KAL_DIALOG_DATA, KalDialogRef } from '@kalidea/kaligraphi';
import { MailContext } from 'src/app/_core/services/mail.service';
import { ColumnsCSV, exportListAsCSV } from 'src/app/utils/kal-table-csv-export.utils';

export interface SharedMailNonContactableBeneficiariesDialogData {
    countContactedBeneficiaries?: number;
    context?: MailContext;
    nonContactableBeneficiariesList?: BeneficiaireAvecMailsModel[];
}

@Component({
    selector: 'app-shared-mail-non-contactable-beneficiaries-dialog',
    templateUrl: './shared-mail-non-contactable-beneficiaries-dialog.component.html',
    styleUrls: ['./shared-mail-non-contactable-beneficiaries-dialog.component.sass'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SharedMailNonContactableBeneficiariesDialogComponent {

    constructor(private dialogRef: KalDialogRef<SharedMailNonContactableBeneficiariesDialogComponent>,
                @Inject(KAL_DIALOG_DATA) public data: SharedMailNonContactableBeneficiariesDialogData) {
    }

    get context(): MailContext {
        return this.data.context || 'mail';
    }

    get nonContactableBeneficiariesList(): BeneficiaireAvecMailsModel[] {
        return this.data.nonContactableBeneficiariesList || [];
    }

    get title(): string {
        const isMultiple = this.data.countContactedBeneficiaries > 1;
        const isCountEmpty = this.data.countContactedBeneficiaries === 0;

        if (isCountEmpty) {
            return this.nonContactableBeneficiariesList.length > 1 ? 'Bénéficiaires non contactables' : 'Bénéficiaire non contactable';
        }

        switch (this.context) {
            case 'mail':
                return isMultiple ? 'E-Mails envoyés' : 'E-Mail envoyé';
            case 'letter':
                return isMultiple ? 'Courriers envoyés' : 'Courrier envoyé';
            case 'newsletter':
                return isMultiple ? 'Newsletter envoyée' : 'Newsletter envoyée';
        }
    }

    get content(): string {
        const isMultiple = this.data.countContactedBeneficiaries > 1;
        const beneficiaryLabel = this.data.countContactedBeneficiaries + ' ' + (isMultiple ? 'bénéficiaires' : 'bénéficiaire');

        switch (this.context) {
            case 'mail':
                return `L'e-Mail a été envoyé à ${beneficiaryLabel}.`;
            case 'letter':
                return `Le courrier a été imprimé pour ${beneficiaryLabel}.`;
            case 'newsletter':
                return `La newsletter a été envoyée à ${beneficiaryLabel}.`;
        }
    }

    export(): void {
        const columns: ColumnsCSV<BeneficiaireAvecMailsModel>[] = [
            {code: 'Matricule', label: 'Matricule'},
            {code: 'Nom', label: 'Nom'},
            {code: 'Prenom', label: 'Prénom'},
            {code: 'MailPerso', label: 'E-Mail perso.'},
            {code: 'MailPro', label: 'E-Mail pro.'}
        ];

        exportListAsCSV(this.nonContactableBeneficiariesList, columns, 'beneficiaires_non_contactable');
    }

    close(): void {
        this.dialogRef.close();
    }
}
